export default __webpack_public_path__ + "static/media/logo.b861900c.png";